import { FC } from 'react';

import styles from '../../Encounters.module.scss';
import { UseEncountersPageResult } from '../../hooks';
import { EncountersFilters } from '../EncountersFilters/EncountersFilters';
import { EncountersList } from '../EncountersList/EncountersList';

type EncountersListPaneProps = Pick<
  UseEncountersPageResult,
  | 'groups'
  | 'hasMore'
  | 'listState'
  | 'loadingMore'
  | 'searchQuery'
  | 'selectedEncounterId'
  | 'selectedSchemaCode'
  | 'sentinelRef'
  | 'setSearchQuery'
  | 'setSelectedSchemaCode'
  | 'selectEncounter'
  | 'usedSchemas'
>;

export const EncountersListPane: FC<EncountersListPaneProps> = (props) => {
  const {
    groups,
    hasMore,
    listState,
    loadingMore,
    searchQuery,
    selectedEncounterId,
    selectedSchemaCode,
    sentinelRef,
    setSearchQuery,
    setSelectedSchemaCode,
    selectEncounter,
    usedSchemas,
  } = props;

  return (
    <div className={styles.list} data-section="encounters-list-pane">
      <EncountersFilters
        searchQuery={searchQuery}
        selectedSchemaCode={selectedSchemaCode}
        usedSchemas={usedSchemas}
        onSearchQueryChange={setSearchQuery}
        onSchemaCodeChange={setSelectedSchemaCode}
      />
      <EncountersList
        groups={groups}
        hasMore={hasMore}
        listState={listState}
        loadingMore={loadingMore}
        selectedEncounterId={selectedEncounterId}
        sentinelRef={sentinelRef}
        onSelect={selectEncounter}
      />
    </div>
  );
};
